@if (this.isLoaded==true && this.isTeamLoaded==true) {
  <div style="margin-left: 20px;">
    @if (this.AssignedProgram.Status=='DRAFT') {
      <h3>EDIT PROGRAM</h3>
    }
    @if (this.AssignedProgram.Status=='ACTIVE') {
      <h3>VIEW PROGRAM</h3>
    }
    <form [formGroup]="programForm" (ngSubmit)="save()" autocomplete="off">
      <mat-form-field appearance="fill"  style="width: 400px;">
        <mat-label>Title</mat-label>
        <input matInput placeholder="Enter a name for the program" formControlName="Title" id="Title" />
        <!-- <mat-icon matSuffix>sentiment_very_satisfied</mat-icon> -->
        <!--  <mat-hint>Max length 50 characters</mat-hint>  -->
      </mat-form-field>
      <br/>
      <mat-form-field appearance="fill"  style="width: 400px;" class="smallinput">
        <mat-label>Description</mat-label>
        <input matInput formControlName="Description" id="Description" />
      </mat-form-field>
      <br>
        <mat-form-field appearance="fill"  style="width: 400px;" class="smallinput">
          <mat-label>Team</mat-label>
          <mat-select matSelect formControlName="TeamId" [disabled]="this.AssignedProgram.Status=='ACTIVE'" >
            @for (team of this.Teams; track team;) {
              <mat-option [value]="team.TeamId">{{team.Name}} - {{team.LevelName}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <br/>
<!--         <mat-form-field style="max-width: 770px; min-width: 570px;" appearance="fill" formArrayName="AssignedPlayers">
          <mat-label>Assigned players</mat-label>
          <mat-chip-listbox mat-chip-listbox #chipList aria-label="Player selection">
            @for (player of this.assignedPlayers?.controls; track player; let i = $index) {
              <mat-chip-option
                [formGroupName]="i"
                >
                <mat-icon>person</mat-icon>
                {{player.get('LastName').value}}, {{player.get('FirstName').value}}
              </mat-chip-option>
            }
          </mat-chip-listbox>
        </mat-form-field> -->
        <mat-form-field style="max-width: 770px; min-width: 570px;" appearance="fill">
  <mat-label>Assigned players</mat-label>
  <mat-chip-grid #chipGrid formArrayName="AssignedPlayers">
    @for (player of this.assignedPlayers?.controls; track player; let i = $index) {
      <mat-chip-row [formGroupName]="i">
        <mat-icon>person</mat-icon>
        {{player.get('LastName').value}}, {{player.get('FirstName').value}}
      </mat-chip-row>
    }
  </mat-chip-grid>
</mat-form-field>
        <br/>
        <input type="hidden" formControlName="Status" id="Status">
        <mat-form-field appearance="fill"  style="width: 200px;">
          <mat-label>Status</mat-label>
          <input matInput formControlName="StatusDisplay" id="StatusDisplay"  />
          <!-- <mat-icon matSuffix>sentiment_very_satisfied</mat-icon> -->
          <!--  <mat-hint>Max length 50 characters</mat-hint>  -->
        </mat-form-field>
        <!-- <mat-form-field appearance="fill" class="smallinput">
        <mat-label  class="smallinput">Status</mat-label>
        <mat-select  class="smallinput" formControlName="Status" id="Status" [value]="this.programForm.Status"  >
          <mat-option value="DRAFT">DRAFT</mat-option>
          <mat-option value="ACTIVE">ACTIVE</mat-option>
          <mat-option value="ARCHIVED">ARCHIVED</mat-option>
        </mat-select>
      </mat-form-field>  -->
      <br/>
      <br/>
      <label>WORKOUTS</label>
      <!-- <button mat-button type="button" (click)="addWeek()">ADD WEEK</button>&nbsp;<br/> -->
      <br/>
      <mat-divider></mat-divider>
      <br/>
      <div  formArrayName="Weeks">
        @for (week of this.programForm.get('Weeks').controls; track week; let weekNo = $index) {
          <div [formGroupName]="weekNo">
            <!--  <div> -->
            <div  class="example-box">
              <div  formArrayName="Days" style=" height: 4; display: flex; flex-direction: row; flex-wrap: wrap; " >
                @for (theDay of week.get('Days')?.controls; track theDay; let dayno = $index) {
                  <div    class="dayframe" [formGroupName]="dayno">
                    <div style="display: flex; flex-direction: column;">
                      <div style="text-align: center;" >
                        <h2>
                          {{this.DayNames[dayno%7]}}
                        </h2>
                        <h3>
                          {{theDay.get('Date').value | date}}
                        </h3>
                        <mat-divider></mat-divider>
                      </div>
                      <div formArrayName="AssignedWorkouts" style="margin-left: 10px;"  >
                        <!-- <div
                        cdkDropList
                        [id]="'Day_' + (dayno) + '_' + (weekNo)"
                        [cdkDropListData]="theDay.get('ProgramWorkouts')?.controls"
                        [cdkDropListConnectedTo]="this.droptargets"
                        class="example-list"
                        (cdkDropListDropped)="drop1($event)"> -->
                        <div
                          [id]="'Day_' + formatDateForDiv(theDay.get('Date').value)"
                          cdkDropList
                          [cdkDropListData]="theDay.get('AssignedWorkouts')?.controls"
                          [cdkDropListConnectedTo]="this.droptargets"
                          (cdkDropListDropped)="drop1($event)"
                          class="example-list"
                          >
                          @for (workout of theDay.get('AssignedWorkouts')?.controls; track workout; let workoutindex = $index) {
                            <div [formGroupName]="workoutindex" class="workout" cdkDrag>
                              <mat-expansion-panel cdkDrag  >
                                <mat-expansion-panel-header style="padding: 0px 8px;background-color: dodgerblue;">
                                  <mat-panel-title style="font-family: Roboto; font-size: small;">
                                    {{workout.get('Name').value}}<br/>
                                    <!--  <span style="font-size: 12px; min-width: 22px;">
                                    <mat-icon  style="font-size: 12px;width: 12px;">person</mat-icon>
                                    {{workout.get('NoOfAssignedPlayers').value}}
                                  </span> -->
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <div style="margin-left: -15px;">
                                @for (section of getWorkout(workout.get('AssignedWorkoutId').value)?.Workout.Sections; track section) {
                                  <div class="woSection" >
                                    {{ section.Name }}
                                  </div>
                                  @for (exercise of section.Exercises; track exercise) {
                                    <div class="woExercise">
                                      {{exercise.Name}}
                                    </div>
                                  }
                                }
                              </div>
                            </mat-expansion-panel>
                            <!-- <div  >
                            <div style="display: flex; align-items: center;">
                              <mat-icon>view_list</mat-icon>
                              <label>
                                {{workout.get('Name').value}}
                              </label>
                            </div>
                          </div> -->
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <!--  <input  formControlName="Day" id="Day"/> -->
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <br/>
  <br/>
  @if (this.AssignedProgram.Status=='DRAFT') {
    <button mat-raised-button type="button" color="primary" (click)="save()" [disabled]="!this.programForm.valid">SAVE</button>
    }&nbsp;
    @if (this.AssignedProgram.Status=='DRAFT') {
      <button mat-raised-button type="button" color="primary" (click)="saveActivate()" [disabled]="!this.programForm.valid">SAVE AND ACTIVATE</button>
      }&nbsp;
      @if (this.AssignedProgram.Status=='DRAFT') {
        <button mat-raised-button type="button" (click)="cancel()" >CANCEL</button>
      }
      @if (this.AssignedProgram.Status=='ACTIVE') {
        <button mat-raised-button type="button" (click)="cancel()" >CLOSE</button>
      }
    </form>
  </div>
}